import { StatusOverview } from "../components/StatusOverview";

/**
 * "Entingen overzicht" route — the present-animal vaccination-status overview (Jmix
 * `EntingenOverzichtView` migration). A thin shell wiring the reusable {@link StatusOverview} to the
 * `entingen-overzicht` feed (GET /api/entingen-overzicht; the treatment-type filter param is
 * `entingstype`) and the animal-detail + producten navigation.
 */
export function EntingenOverzicht({
  onOpenAnimal,
}: {
  onOpenAnimal: (dierId: string, inentingId?: number | null) => void;
}) {
  return (
    <StatusOverview
      config={{
        variant: "entingen",
        endpoint: "entingen-overzicht",
        typeParam: "entingstype",
        i18nPrefix: "entingenOverzicht",
      }}
      onOpenAnimal={onOpenAnimal}
    />
  );
}
